import React from "react";

const Top: React.FC = (_) => {
  window.location.href = "https://www.nanala.jp/school/online/";
  return <></>;
};

export default Top;
